import { LegacyRef, MutableRefObject, Ref, RefCallback, useEffect, useMemo } from "react";

export function mergeRefs<T = any>(
  refs: Array<MutableRefObject<T> | LegacyRef<T> | undefined>,
): RefCallback<T> {
  return (value) => {
    refs.forEach((ref) => {
      if (typeof ref === "function") {
        ref(value);
      } else if (ref != null) {
        (ref as MutableRefObject<T | null>).current = value;
      }
    });
  };
}

export function setInRef<T>(ref: Ref<T> | MutableRefObject<T> | undefined, value: any) {
  if (ref) {
    if (typeof ref === "function") {
      ref(value);
    } else {
      (ref as MutableRefObject<T>).current = value;
    }
  }
}

export function useRefEffect<T, R = T>(ref: Ref<T> | undefined, refInfo: R) {
  useEffect(() => {
    setInRef(ref, refInfo);
    return () => setInRef(ref, null);
  }, [ ref, refInfo ]);
}

export function useMergedRef<T>(...refs: Array<Ref<T> | undefined>) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => mergeRefs([ ...refs ]), [ ...refs ]);
}
